export enum OFFER_PROMOTION_TYPES {
  FREEBIE = 'freebie'
}
